import { Alert } from '@mui/material';
import SecurityIcon from '@mui/icons-material/Security';
import styles from './ChatWidget.module.scss';

function RecaptchaText() {
    const lang = document.documentElement.lang || navigator.language;

    let content = <>This page is protected by reCAPTCHA and is subject to Google's {" "}
        <u><a href="https://policies.google.com/privacy?hl=en" target="_blank">Privacy Policy</a></u> and{" "}
        <u><a href="https://policies.google.com/terms?hl=en" target="_blank">Terms of Service</a></u>.</>;

    if (lang && lang.toLowerCase().startsWith("de")) {
        content = <>Diese Seite ist durch reCAPTCHA geschützt und unterliegt den Google-
            <u><a href="https://policies.google.com/privacy?hl=de" target="_blank">Datenschutzerklärung</a></u> sowie den{" "}
            <u><a href="https://policies.google.com/terms?hl=de" target="_blank">Nutzungsbedingungen</a></u>.</>;
    }

    return <Alert className={styles.recaptchaNote} icon={<SecurityIcon fontSize="inherit" />} severity="info">
        {content}
    </Alert>
}

export default RecaptchaText;
